<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M17.7513 10.1914H14.8513C14.0346 10.1914 13.3096 10.6414 12.943 11.3747L12.243 12.7581C12.0763 13.0914 11.743 13.2997 11.3763 13.2997H8.64297C8.38463 13.2997 8.01797 13.2414 7.7763 12.7581L7.0763 11.3831C6.70964 10.6581 5.9763 10.1997 5.16797 10.1997H2.2513C1.9263 10.1997 1.66797 10.4581 1.66797 10.7831V13.4997C1.66797 16.5247 3.48464 18.3331 6.51797 18.3331H13.5013C16.3596 18.3331 18.118 16.7664 18.3346 13.9831V10.7747C18.3346 10.4581 18.0763 10.1914 17.7513 10.1914Z"
      fill="currentColor"
    />
    <path
      d="M10.625 3.17292L11.225 3.77292C11.35 3.89792 11.5083 3.95625 11.6666 3.95625C11.825 3.95625 11.9833 3.89792 12.1083 3.77292C12.35 3.53125 12.35 3.13125 12.1083 2.88958L10.4416 1.22292C10.4333 1.21458 10.425 1.21458 10.425 1.20625C10.375 1.15625 10.3083 1.11458 10.2416 1.08125C10.2333 1.08125 10.2333 1.08125 10.225 1.07292C10.1583 1.04792 10.0916 1.03958 10.025 1.03125C9.99998 1.03125 9.98332 1.03125 9.95832 1.03125C9.90832 1.03125 9.85832 1.04792 9.80832 1.06458C9.78332 1.07292 9.76665 1.08125 9.74998 1.08958C9.68332 1.12292 9.61665 1.15625 9.56665 1.21458L7.9 2.88125C7.65833 3.12292 7.65833 3.52292 7.9 3.76458C8.14167 4.00625 8.54165 4.00625 8.78332 3.76458L9.38332 3.16458V4.16458H10.6333V3.17292H10.625Z"
      fill="currentColor"
    />
    <path
      d="M18.3346 9.00964V9.04297C18.1513 8.9763 17.9513 8.94297 17.7513 8.94297H14.8513C13.5596 8.94297 12.4013 9.65964 11.8263 10.8096L11.2013 12.043H8.81797L8.19297 10.818C7.61797 9.65964 6.45964 8.94297 5.16797 8.94297H2.2513C2.0513 8.94297 1.8513 8.9763 1.66797 9.04297V9.00964C1.66797 5.9763 3.4763 4.16797 6.50964 4.16797H9.3763V7.5013C9.3763 7.84297 9.65964 8.1263 10.0013 8.1263C10.343 8.1263 10.6263 7.84297 10.6263 7.5013V4.16797H13.493C16.5263 4.16797 18.3346 5.9763 18.3346 9.00964Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'BulkMessagesIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>